export const NON_RECURRING_CHOICES = {
  PASS_ONE: 'PASS_ONE',
  PASS_TWO: 'PASS_TWO',
  PASS_THREE: 'PASS_THREE',
};

export const LEARN_MORE_LINK = `https://www.coursera.support/s/article/360036151872-Coursera-Plus`;
